import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { LinkRegistryService } from '../link-registry.service';
import { EXPORT_CONFIGURATION } from './export.domain';

import type { ExportEvent, ExportConfiguration, ExportRequest } from './export.domain';

/**
 * This Service is used for exporting (downloading) file from backend server.
 *
 * This parameter data will be transferred to ExportComponent.
 *
 */
@Injectable({
  providedIn: 'root'
})
export class ExportService {
  private readonly linkRegistryService = inject<LinkRegistryService>(LinkRegistryService);

  readonly onExport = new Subject<ExportEvent>();

  private readonly exportServiceUrl: string;
  private readonly restConsumerName: string;

  constructor() {
    const configuration = inject<ExportConfiguration>(EXPORT_CONFIGURATION, { optional: true });

    if (configuration !== null) {
      this.exportServiceUrl = configuration.exportServiceUrl;
      this.restConsumerName = configuration.restConsumerName;
    }
  }

  exportData(exportRequest: ExportRequest): void {
    this.onExport.next({
      exportRequest,
      exportServiceUrl: this.getExportServiceUrl(),
      restConsumerName: this.getRestConsumerName()
    });
  }

  getUrl(request: ExportRequest): string {
    const exportRequest = JSON.stringify({
      type: request.exportType,
      fileFormat: request.fileFormat,
      contentDisposition: request.contentDisposition
    });
    const exportParams = JSON.stringify(request.exportParams);
    return this.linkRegistryService.addParameters(this.exportServiceUrl,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      { exportRequest, exportParams, 'x-consumer-name': this.getRestConsumerName() });
  }

  getExportServiceUrl(): string {
    return this.exportServiceUrl;
  }

  private getRestConsumerName(): string {
    return this.restConsumerName;
  }
}
